// PhonicsLt13.js
// 包装组件：Letter Teams L13
// 路由：/phonics/lt13
import React from 'react';
import PhonicsLt from './phonics/PhonicsLt';
import { letterDataLt13 } from './phonics/phonics_data_lt13';

function PhonicsLt13() {
  return <PhonicsLt letterData={letterDataLt13} />;
}

export default PhonicsLt13;
